import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { toggleElement, toggleClass } from '@fretadao/f-js-dom';

application.register(
  'b2b-admin-map',
  class extends Controller {
    static targets = [
      'routes', 'passengers', 'ingoing', 'outgoing',
      'routesBtn', 'passengersBtn', 'ingoingBtn', 'outgoingBtn'
    ];

    filter = { kind: 'routes', direction: 'ingoing' };

    connect() {
    }

    showRoutes() {
      this.#show({ kind: 'routes' });
    }

    showPassengers() {
      this.#show({ kind: 'passengers' });
    }

    showRoutesOnMobile() {
      this.#show({ kind: 'routes' });
    }

    showPassengersOnMobile() {
      this.#show({ kind: 'passengers' });
    }

    showIngoing() {
      this.#show({ direction: 'ingoing' });
    }

    showOutgoing() {
      this.#show({ direction: 'outgoing' });
    }

    #show(filter) {
      let changeFilterBy = null;

      if(filter.kind && filter.kind !== this.filter.kind) {
        changeFilterBy = 'kind';
      } else if(filter.direction && filter.direction !== this.filter.direction) {
        changeFilterBy = 'direction';
      } else {
        return;
      }

      this.filter = Object.assign(this.filter, filter);

      if(changeFilterBy === 'kind') {
        this.#toggleElements(this.routesTargets);
        this.#toggleElements(this.passengersTargets);
        toggleClass(this.routesBtnTargets, 'bt--outlined-active');
        toggleClass(this.passengersBtnTargets, 'bt--outlined-active');
      } else {
        this.#toggleElements(this.ingoingTargets);
        this.#toggleElements(this.outgoingTargets);
      }
    }

    #toggleElements(elements) {
      elements.forEach(target => toggleElement(target));
    }
  }
);
